module.exports = __webpack_public_path__ + "images/business-class/feature-control.4e47ce655980f89f0661.svg";